"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SECONDARY_LINK_DESCRIPTION = exports.DEFAULT_SECONDARY_LINK_LABEL = void 0;
/**
 * Platform defaults for the candidate lobby's secondary link — the
 * "Request a live call instead" affordance under the Start-call CTA.
 *
 * A template version can override each part independently (see the
 * `secondaryLinkLabel` / `secondaryLinkDescription` columns on
 * InterviewTypeVersion): null follows these defaults, "" hides that part, and
 * any other string is a custom override. The candidate config resolves the
 * stored value against these constants server-side, so the interview app only
 * ever renders what it is served.
 *
 * These were previously hardcoded in the interview app's LobbyScreen; they live
 * here so the API (resolution) and the console (live preview) share one source.
 */
exports.DEFAULT_SECONDARY_LINK_LABEL = 'Request a live call instead';
exports.DEFAULT_SECONDARY_LINK_DESCRIPTION = 'An equivalent evaluation with a person, with the same badging outcomes — ' +
    'available as a disability accommodation or for any other reason.';
